<template>
    <div class="search-ms___panel_input" style="margin-top: 10px;">
        <label v-if="isLabel" for="">{{placeholder}}</label>
        <input type="text" class="search-ms__input" 
               :placeholder="placeholder" 
               :value="modelValue" 
               @keypress="initSearch"
               @input="input">
        <img v-if="!noSearch" @click="initSearch" src="../../assets/search.svg" alt="">
        
    </div>
</template>
<script>
export default{
    methods:{
        input(e){
            this.value = e.target.value
            this.$emit('update:modelValue', e.target.value); 

        },
        initSearch(e){
            if (e.type == 'click'){
                this.$emit('click', this.value)
            }
            if (e.type == 'keypress' && e.key == 'Enter'){
                 this.$emit('click', this.value)
            }
        }
    },
    emits:['update:modelValue','click'],        
    props:{
        isLabel:{type:Boolean,default:false},
        placeholder:{type:String},
        modelValue:{type:String},
        noSearch:{type:Boolean,default:false}
    },
    data(){
        return{
            value:''
        }
    }
}
</script>
<style>
/* -------- sherch -------- */
    .search-ms___panel_input{
        height: 42px;
        width: 333px;
        position: relative;
    }
    .search-ms__input{
        font-family: Rubik,sans-serif;
        font-size: 14px;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 68px;
        background-color:#EDF6FF;
        border:1px solid #EDF6FF;
        border-radius: 10px;
        position: relative;
    }
    .search-ms__input::placeholder{
        font-size: 14px;
        letter-spacing: 0.02em;
    }
    .search-ms__input:focus{
        outline: none;
        border-color: #007BB8 ;
    }
    .search-ms__input:focus::placeholder{
        font-size: 14px;
        letter-spacing: 0.02em;
        
    }
    .search-ms___panel_input img{
        position: absolute;
        transform: translateY(-50%);
        top:calc(50%);
        right:20px;
        cursor: pointer;
    }
    .search-ms___panel_input label{
        position: absolute;
        top: -10px;
        left: 10px;
        z-index: 2;
        background: linear-gradient(0deg,rgba(237, 246, 255, 1) 0%, rgba(237, 246, 255, 1) 50%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 1) 100%);
    }
/* !------- sherch -------! */
</style>